import { PortalExtractionComponent } from "@/features/esoPerson/portalExtraction/PortalExtractionComponent"

export const PortalExtractionPage = () => {
  return <PortalExtractionComponent />
}
